import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as moment from 'moment';
import 'moment-timezone';
import { NgxSpinnerService } from "ngx-spinner";

import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
    selector: 'app-infograph',
    templateUrl: './infograph.component.html',
    styleUrls: ['./infograph.component.css']
})
export class InfographComponent implements OnInit {

    public project_id: any = {};
    public project = '';
    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public summary: any = {};
    public top_categories = [];
    public influential_mentions = [];
    public active_mentions = [];

    public doughnutChartdata = [];
    public doughnutChartLabels = [];
    public doughnutChartColors = [];

    ChartDataSets = [];
    sentimantLineChartData = []
    lineChartData = []
    lineChartLegend = true;
    lineChartPlugins = [];
    lineChartType = 'line';
    public lineChartOptions: (ChartOptions & { annotation: any }) = {
        responsive: true,
        //    maintainAspectRatio: false,
        legend: { display: true },
        scales: {
            yAxes: [
                {
                    ticks: {
                        maxTicksLimit: 8
                    }
                }
            ],
            xAxes: [
                {
                    type: 'time',
                    distribution: 'series',
                    time: {
                        tooltipFormat: 'DD MMM',
                        displayFormats: {
                            'millisecond': '',
                            'second': 'DD MMM',
                            'minute': 'DD MMM',
                            'hour': 'DD MMM',
                            'day': 'DD MMM',
                            'week': 'DD MMM',
                            'month': 'DD MMM',
                            'quarter': 'DD MMM',
                            'year': 'DD MMM',
                        }
                    }
                },
            ]
        },
        annotation: {},
    };

    public doughnutChartOptions: any = {
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var label = data.labels[tooltipItem.index];
                    var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                        return parseInt(previousValue) + parseInt(currentValue);
                    });
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                    return label + ': ' + percentage + "%";
                }
            }
        },
        legend: {
            display: true,
            position: 'right',
            labels: {
                fontSize: 10,
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        return data.labels.map(function(label, i) {
                            var ds = data.datasets[0];
                            var color = ds.backgroundColor[i];
                            var total = ds.data.reduce((a, b) => parseInt(a) + parseInt(b), 0);
                            console.log(ds.data);
                            var percentage = Math.floor(((ds.data[i] / total) * 100) + 0.5);
                            return { text: percentage + "% " + label, fillStyle: color };
                        });
                    }
                }
            }
        }
    };
    public doughnutChartData: any = [];
    public doughnutChartLegend = true;
    public doughnutChartType: ChartType = 'pie';

    constructor(private router: Router, private service: DashboardService, private login: LoginService, private route: ActivatedRoute, private spinner: NgxSpinnerService) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.service.setTitle('Infographic | 24ieye');
        this.project_id = this.route.snapshot.queryParams["id"];
    }

    ngOnInit(): void {
        this.get_mentions_per_sm(moment().subtract(90, 'days').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), this.route.snapshot.queryParams["id"]);
        this.get_mentions_graph(moment().subtract(90, 'days').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), this.route.snapshot.queryParams["id"]);
        this.get_mentions(moment().subtract(90, 'days').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), 'all', 'influential', 15);
        this.get_mentions(moment().subtract(90, 'days').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), 'all', 'active', 15);
        //      this.get_mentions(moment().subtract(90, 'days').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), 'all', 'sites', 15);
    }

    public async get_mentions(start, end, mention_type, list_type, page_length) {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", mention_type);
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", page_length);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        if (list_type == 'influential') {
            formData.append("sort", 'engagement');
        }
        if (list_type == 'active') {
            formData.append("sort", 'rank');
        }
        if (list_type == 'sites') {
            formData.append("sort", 'rank');
            formData.append("channels[twitter]", true);
            formData.append("channels[facebook]", true);
            formData.append("channels[instagram]", true);
            formData.append("channels[web]", false);
            formData.append("channels[youtube]", true);
            formData.append("channels[reviews]", false);
            formData.append("channels[others]", false);
            formData.append("channels[all]", false);
        } else {
            formData.append("channels[twitter]", true);
            formData.append("channels[facebook]", true);
            formData.append("channels[instagram]", true);
            formData.append("channels[web]", false);
            formData.append("channels[youtube]", true);
            formData.append("channels[reviews]", false);
            formData.append("channels[others]", false);
            formData.append("channels[all]", false);
        }
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            if (list_type == 'influential') {
                this.influential_mentions = this.get_unique_data(this.result.data.mentions, 5);

            }
            if (list_type == 'active') {
                this.active_mentions = this.get_unique_data(this.result.data.mentions, 5);
            }
        }
    }

    public get_unique_data(data, length) {
        var going = true;
        var res = [];
        var saved = [];
        data.forEach((val, index) => {
            if (going) {
                if (saved.indexOf(val.uid) == -1) {
                    saved.push(val.uid);
                    res.push(val);
                }
                if (res.length === length) {
                    going = false;
                    return res;
                }
            }
        });
        return res;
    }

    public async get_mentions_per_sm(start, end, project_id) {
        this.summary.all = this.summary.interactions = this.summary.positive = this.summary.negative = this.summary.sm = '<img src="assets/images/small-loader.gif">';
        this.spinner.show();
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'count_per_sm');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 90);
        formData.append("project_id", project_id);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.spinner.hide();
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.get_doughnut_chart(this.result.data);

            this.summary.all = this.result.data.all;
            this.summary.positive = this.result.data.positive;
            this.summary.negative = this.result.data.negative;

            this.get_top_categories(this.result.data);
            this.spinner.hide();
        }
    }

    public get_doughnut_chart(data) {
        var chart_data = [];
        var colours = [];
        var labels = [];
        if (data.web != 'denied') {
            labels.push('Web');
            chart_data.push(data.web);
            colours.push('#4392B7');
        }
        if (data.twitter != 'denied') {
            labels.push('Twitter');
            chart_data.push(data.twitter);
            colours.push('#37A9F3');
        }
        if (data.instagram != 'denied') {
            labels.push('Instagram');
            chart_data.push(data.instagram);
            colours.push('#F7C050');
        }
        if (data.facebook != 'denied') {
            labels.push('Facebook');
            chart_data.push(data.facebook);
            colours.push('#4867AA');
        }
        if (data.youtube != 'denied') {
            labels.push('Youtube');
            chart_data.push(data.youtube);
            colours.push('#FF4A4A');
        }
        if (data.reviews != 'denied') {
            labels.push('Reviews');
            chart_data.push(data.reviews);
            colours.push('#038c99');
        }
//        if (data.others != 'denied') {
//            labels.push('Others');
//            chart_data.push(data.others);
//            colours.push('#f47424');
//        }
        if (data.others != 'denied') {
            labels.push('Linkedin');
            chart_data.push(data.linkedin);
            colours.push('#0077b5');
        }
        if (data.others != 'denied') {
            labels.push('Reddit');
            chart_data.push(data.reddit);
            colours.push('#FF4500');
        }

        this.doughnutChartdata = chart_data;
        this.doughnutChartLabels = labels;
        this.doughnutChartColors = [{ backgroundColor: colours }];
    }

    public get_top_categories(data) {
        this.top_categories = [];
        let sm = {
            "entity": {
                "Web": data.web == false ? 0 : data.web,
                "Twitter": data.twitter == false ? 0 : data.twitter,
                "Instagram": data.instagram == false ? 0 : data.instagram,
                "Facebook": data.facebook == false ? 0 : data.facebook,
                "Youtube": data.youtube == false ? 0 : data.youtube,
                "Reviews": data.reviews == false ? 0 : data.reviews,
                "Others": data.others == false ? 0 : data.others
            }
        },
            mymap = sm.entity;

        let elements = Object.keys(mymap)
            .sort((a, b) => mymap[b] - mymap[a])
            .slice(0, 3);
        var val_array = elements.map(key => mymap[key]);
        //    var total = val_array.reduce(function(previousValue, currentValue, currentIndex, array) {
        //            return parseInt(previousValue) + parseInt(currentValue);
        //      });
        var total = this.get_total(data);
        elements.forEach((values, index) => {
            if (sm.entity[values]) {
                var percentage = Math.floor(((sm.entity[values] / total) * 100) + 0.5);
                this.top_categories.push({ category: values, value: sm.entity[values], percentage: percentage });
            }
        });
    }

    public get_total(data) {
        var total = 0;
        if (data.web != 'denied')
            total = total + parseInt(data.web);
        if (data.twitter != 'denied')
            total = total + parseInt(data.twitter);
        if (data.instagram != 'denied')
            total = total + parseInt(data.instagram);
        if (data.facebook != 'denied')
            total = total + parseInt(data.facebook);
        if (data.youtube != 'denied')
            total = total + parseInt(data.youtube);
        if (data.reviews != 'denied')
            total = total + parseInt(data.reviews);
        if (data.others != 'denied')
            total = total + parseInt(data.others);

        return total;
    }

    public async get_mentions_graph(start, end, project_id) {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'mentions_map');
        formData.append("sentiment_data", true);
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 5);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.project = this.result.project.name;
            this.lineChartData = [
                { data: this.result.data, label: this.result.project.name, borderWidth: 2, pointRadius: 2, lineTension: 0, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#0077CC', pointBorderColor: '#0077CC', pointBackgroundColor: '#0077CC' }
            ];
            this.sentimantLineChartData = [
                { data: this.result.positive_data, label: 'Positive', borderWidth: 2, pointRadius: 2, lineTension: 1, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#45D52B', pointBorderColor: '#45D52B', pointBackgroundColor: '#45D52B' },
                { data: this.result.negative_data, label: 'Negative', borderWidth: 2, pointRadius: 2, lineTension: 1, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#FF0000', pointBorderColor: '#FF0000', pointBackgroundColor: '#FF0000' },
            ];
        }
    }

}
